import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import ProjectNamePopup from "./ProjectNamePopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { ProjectNameDataDDL } from "../../../../Components/CommonDDL/ProjectNameDataDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { ProjectDeleteAPI, ProjectExportTableDataAPI, ProjectTableDataAPI } from "../../../../Redux/SidebarMasterSlice/ProjectNameSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { useSearchParams } from "react-router-dom"
import { GDProjectNameDDL } from "../../../../Components/CommonDDL/GDProjectNameDDL"
import { ProjectNameExportData } from "./ProjectNameExportData"

export const ProjectName = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeFlag = searchParams.get("ProjectTypeFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    // console.log('ProjectTypeId', ProjectTypeId)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [SectorMasterPopupShow, setSectorMasterPopupShow] = useState()
    const [ProjectNamePopupShow, setProjectNamePopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)

    const [MasterPopupShow, setMasterPopupShow] = useState()

    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setProjectNamePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setProjectNamePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setProjectNamePopupShow(false)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...'
        })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...'
        })
        // setProjectType({
        //     ...ProjectType,
        //     ID: 0,
        //     Label: 'Select...'
        // })
    }

    useEffect(() => {

        const data = {
            M_ProjectID: ProjectName.ID,
            ProjectName: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            M_WardID: WardName.ID,
            M_ProjectType: DashProjectTypeId == "6" ? "WaterSupplyDistributionLine" : DashProjectTypeId == "1" ? "WaterSupply" : DashProjectTypeId == "7" ? "WTP"
                : ProjectTypeId == "2" ? "Sewerage" : ProjectTypeId == "3" ? "STP" : ProjectTypeId == "4" ? "RoadWork" : ProjectTypeId == "8" ? "Electrical" : 
                ProjectTypeId == "9" ? "TTP" : "Garden",
            handleProjectNameExport: handleProjectNameExport

        }
        dispatch(ProjectTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.ProjectTableData)

    const handleProjectNameExport = () => {

        const data = {
            M_ProjectID: ProjectName.ID,
            ProjectName: '',
            M_UsersID: UserID,
            token: token,
            From: '1',
            To: '99999',
            M_WardID: WardName.ID,
            M_ProjectType: DashProjectTypeId == "6" ? "WaterSupplyDistributionLine" : DashProjectTypeId == "1" ? "WaterSupply" : DashProjectTypeId == "7" ? "WTP"
                : ProjectTypeId == "2" ? "Sewerage" : ProjectTypeId == "3" ? "STP" : ProjectTypeId == "4" ? "RoadWork" : ProjectTypeId == "8" ? "Electrical" : 
                ProjectTypeId == "9" ? "TTP" :  "Garden",
        }
        dispatch(ProjectExportTableDataAPI({ data }))
    }
    // , [IsPost, IsClear, isSearch])

    const { ExportTableData, isExportLoading } = useSelector(state => state.ProjectExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_ProjectID: item.m_ProjectID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(ProjectDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.ProjectDeleteData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [ProjectName.ID, WardName.ID, ProjectType.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    // console.log("ProjectTypeFlag::",ProjectTypeFlag)
    console.log("DashProjectTypeId: ", DashProjectTypeId)

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='projectname'
                        ProjectTypeFlag={ProjectTypeFlag}
                        listActive="masters"
                    />
                    <div className="content1">

                        <div className="row m-1 py-1 pb-4 master_border">

                            <div className='col-12 row'>
                                <div className="col-12 col-lg-5">
                                    <h5 className="ps-1 py-1">Project Name Master</h5>
                                </div>

                                <div className="col-12 col-lg-3">
                                    <h5 className="ps-1 py-1">Total Count =
                                        <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                            &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount : '0'}
                                        </text>
                                    </h5>
                                </div>

                                <div className="col-12 col-lg-4 float-end mt-0 pt-1">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            // GardenExporttableData && GardenExporttableData.table && GardenExporttableData.table.length
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <ProjectNameExportData
                                                ExcelData={ExportTableData}
                                                name='Project Name Master'
                                            // searchName={searchName}
                                            />
                                    }

                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                        style={{ color: "white", marginTop: '0%' }} onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>


                            <div className="row m-0 ">
                                <div className="col-12 py-1 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                    <div className="col-12  ">

                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-4 col-lg-3">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    Type={ProjectTypeId == 9 ? "TTP" : "Electrical"}
                                                    APIFlag="ProjectWiseWard"
                                                // Flag='ward'
                                                />

                                            </div>
                                            {/* <div className="col-12 col-md-6 col-lg-3">
                                                <ProjectTypeDataDDL
                                                    ProjectType={ProjectType}
                                                    setProjectType={setProjectType}

                                                />

                                            </div> */}
                                            <div className="col-12 col-md-4 col-lg-3">
                                                <GDProjectNameDDL
                                                    WardName={WardName?.ID}
                                                    ProjectName={ProjectName}
                                                    setProjectName={setProjectName}
                                                    // M_ProjectTypeID={ProjectTypeId == 1 ? DashProjectTypeId : ProjectTypeId}
                                                    M_ProjectTypeID={M_ProjectTypeID}
                                                    IsPost={IsPost}
                                                // DDLFlag='ProjectWiseContractor'
                                                />

                                            </div>

                                            <div className="col-12 col-md-3 col-lg-3 mt-1 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>
                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr >
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Ward Name</th>
                                                        {/* <th>Project Type</th> */}
                                                        <th className="min-w-110">Project Name</th>
                                                        <th className="action-col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                <td>{item.wardName ? item.wardName : '-'}</td>
                                                                {/* <td>{item.projectType ? item.projectType : '-'}</td> */}
                                                                <td>{item.projectName ? item.projectName : '-'}</td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square"
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        ></i>
                                                                    </span>

                                                                    <DeletePopup
                                                                        open={DeletePopupShow}
                                                                        item={item}
                                                                        handleDeleteApi={handleDeleteApi}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))
                                                            :
                                                            <td colSpan={8}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    ProjectNamePopupShow &&
                    <ProjectNamePopup
                        open={ProjectNamePopupShow}
                        handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}
                        rowData={rowData}
                        Flag={apiFlag}
                        DashProjectTypeId={DashProjectTypeId}
                        ProjectTypeId={ProjectTypeId}
                    />
                }
            </div>
        </>
    )
}